/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
*/

import { createAction, props } from '@ngrx/store';

import { DiscountCode } from '@core/models';

export const loadDiscountCodesCount = createAction('[Discount Codes] Load Discount Codes Count');

export const loadDiscountCodesCountSuccess = createAction(
  '[Discount Codes] Load Discount Codes Count Success',
  props<{ discountCodesCount: number }>()
);
export const loadDiscountCodesCountFailure = createAction(
  '[Discount Codes] Load Discount Codes Count Failure',
  props<{ errorMessage: string }>()
);
export const loadDiscountCodes = createAction(
  '[Discount Codes] Load Discount Codes',
  props<{ searchText?: string; from: number; count: number }>()
);

export const loadDiscountCodesSuccess = createAction(
  '[Discount Codes] Load Discount Codes Success',
  props<{ discountCodes: DiscountCode[] }>()
);
export const loadDiscountCodesFailure = createAction(
  '[Discount Codes] Load Discount Codes Failure',
  props<{ errorMessage: string }>()
);

export const loadDiscountCodeById = createAction('[Discount Codes] Load Discount Code By Id', props<{ id: number }>());
export const loadDiscountCodeByIdSuccess = createAction(
  '[Discount Codes] Load Discount Code By Id Success',
  props<{ discountCode: DiscountCode }>()
);
export const loadDiscountCodeByIdFailuiure = createAction(
  '[Discount Codes] Load Discount Code By Id Failure',
  props<{ errorMessage: string }>()
);

export const createDiscountCode = createAction(
  '[Discount Codes] Create Discount Codes',
  props<{ discountCode: DiscountCode }>()
);
export const createDiscountCodeSuccess = createAction(
  '[Discount Codes] Create Discount Codes Success',
  props<{ discountCode: DiscountCode }>()
);
export const createDiscountCodeFailure = createAction(
  '[Discount Codes] Create Discount Codes Failure',
  props<{ errorMessage: string }>()
);

export const updateDiscountCode = createAction(
  '[Discount Codes] Update Discount Codes',
  props<{ discountCode: DiscountCode }>()
);
export const updateDiscountCodeSuccess = createAction(
  '[Discount Codes] Update Discount Codes Success',
  props<{ discountCode: DiscountCode }>()
);
export const updateDiscountCodeFailure = createAction(
  '[Discount Codes] Update Discount Codes Failure',
  props<{ errorMessage: string }>()
);

export const deleteDiscountCode = createAction('[Discount Codes] Delete Discount Codes', props<{ id: number }>());
export const deleteDiscountCodeSuccess = createAction(
  '[Discount Codes] Delete Discount Codes Success',
  props<{ id: number }>()
);
export const deleteDiscountCodeFailure = createAction(
  '[Discount Codes] Delete Discount Codes Failure',
  props<{ errorMessage: string }>()
);
